var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(.5)"},[React.createElement("rect",{"width":"49.421","height":"49.421","fill":"#0D0D0D","rx":"1","key":0}),React.createElement("path",{"fill":"#FFF","fillRule":"nonzero","d":"M17.02 22.114h3.336v10.72H17.02v-10.72zm1.67-5.33a1.932 1.932 0 1 1-.003 3.865 1.932 1.932 0 0 1 .002-3.864m3.757 5.329h3.194v1.465h.045c.445-.843 1.532-1.731 3.153-1.731 3.373 0 3.997 2.22 3.997 5.106v5.88h-3.332V27.62c0-1.243-.021-2.842-1.731-2.842-1.734 0-1.998 1.355-1.998 2.754v5.302h-3.328v-10.72z","key":1})]));
}

LinkedinInline.defaultProps = {"width":"50","height":"50"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
